import styled from 'styled-components'

export const Card = styled.div`
  background: ${props => props.theme.colors.background.primary};
  border-radius: ${props => props.theme.radius.card};
  padding: ${props => props.padding || '1.75rem'};
  box-shadow: 0 2px 8px ${props => props.theme.colors.shadow.light};
  border: 1px solid ${props => props.theme.colors.border.light};
  transition: ${props => props.theme.transitions.default};

  &:hover {
    box-shadow: 0 4px 12px ${props => props.theme.colors.shadow.medium};
  }

  @media (max-width: 480px) {
    padding: 1.25rem;
  }
`
